import type { TRuleWithTheme } from 'styles/theme';

export const label: TRuleWithTheme = ({ theme: { colors } }) => ({
    color: colors.fgSecondary,
    fontSize: '0.875rem',
    lineHeight: '1.0625rem',
});
